module.exports = __webpack_public_path__ + "img/Stemness-LICA_PLC.56a0342e.png";